// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1dPLr","content":"LoadingAlert_content__3geTa"};